// extracted by mini-css-extract-plugin
module.exports = {"skeleton":"article-card-skeleton_skeleton__4MqeN"};